import { Button, FormControl, MenuItem, Select, TextField } from '@material-ui/core';
import Constant from '@/common/constant/Constant';
import {
    addNewProject,
    onChangeProjectName,
    onRemoveProject,
    handleCancelProject,
    handleEditProject,
    onChangeEditProjectName,
    checkDisableBtnSubmit,
    handleSubmitListProject,
    onClickDeleteProject,
    getPermissionCreateProject,
    getPermissionEditProject,
    getPermissionDeleteProject,
    onChangeEditProjectServiceType,
    onChangeProjectServiceType
} from '@/component/system/handler/ProjectManagementHandler';
import { useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import './ProjectManagement.css';
import Utils, { isAdminUser } from '@/common/utils/utils';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom, projectListInCorporationAtom, projectListInCorporationByUserIdAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import LoadingPanel from '../common/LoadingPanel';
import { I18n } from 'aws-amplify';
import CancelDialogProjectManagement from './CancelDialogProjectManagement';
import { useEffect } from 'react';
import DeleteProjectManagementDialog from './DeleteProjectManagementDialog';
import { closeTabId, multiPanelAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import CancelTabsDialog from './dialog/CancelTabsDialog';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import { cloneDeep } from 'lodash';
import { listFormOfCorporationAtom } from '../../state/atom/formAtom';

export default function ProjectManagement(props) {
    const [isLoading, setIsLoading] = useState(false);

    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    const isAdmin = isAdminUser(userDetail);
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    // common projectInuse state
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);
    const [listProject, setListProject] = useRecoilState(isAdmin? projectListInCorporationAtom : projectListInCorporationByUserIdAtom);
    const [listProjectInCorp, setListProjectInCorp] = useRecoilState(projectListInCorporationAtom);
    const [listProjectOfUser,setListProjectOfUser] = useRecoilState(projectListInCorporationByUserIdAtom);
    const [projectAddList, setProjectAddList] = useState([]);
    const [listForm, setListForm] = useRecoilState(listFormOfCorporationAtom);

    const [isOpenConfirmDelete, setIsOpenConfirmDelete] = useState(false);
    const [deleteProject, setDeleteProject] = useState({});
    const [isProjectCanDelete, setIsProjectCanDelete] = useState(true);

    const [listEditProject, setListEditProject] = useState({});
    const [openCancelDialog, setOpenCancelDialog] = useState(false);
    const [initListEditProject, setInitListEditProject] = useState({});
    const [isDisableBtnSubmit, setIsDisableBtnSubmit] = useState(true);
    const { enqueueSnackbar } = useSnackbar();

    const argsAll = {
        ...props,
        isLoading,
        setIsLoading,
        userDetail: userDetail,
        corporationDetail: corporationDetail,
        projectInuseDetail,
        setProjectInuseDetail,
        listProject: listProject,
        setListProject: setListProject,
        listProjectOfUser,
        setListProjectOfUser,
        projectAddList,
        setProjectAddList,
        listProjectInCorp,
        setListProjectInCorp,
        setListEditProject,
        listEditProject,
        setOpenCancelDialog,
        openCancelDialog,
        setInitListEditProject,
        initListEditProject,
        setIsDisableBtnSubmit,
        enqueueSnackbar,
        setIsOpenConfirmDelete,
        isOpenConfirmDelete,
        deleteProject, 
        setDeleteProject,
        isProjectCanDelete, 
        setIsProjectCanDelete,
        isConfirmCancelTabs,
        setIsConfirmCancelTabs,
        isAdmin,
        panelList,
        setPanelList,
        closePanelTab,
        listForm,
        setListForm
    }

    useEffect(() => {
        let projectList = [];
        if (
            !Utils.isEmptyArray(listProjectInCorp) &&
            !Utils.isEmptyArray(listProjectOfUser) &&
            !Utils.isEmptyObject(corporationDetail)
        ) {
            if (isAdmin) {
                projectList = cloneDeep(listProjectInCorp);
            } else {
                projectList = cloneDeep(listProjectOfUser);
            }

            if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)) {
                projectList = projectList.filter(project => {
                    return project.type !== Constant.PROJECT_TYPE.BASE;
                });
            }

            for (let i = 0; i < projectList.length; i++) {
                if (!projectList[i].isDesk) {
                    projectList[i].projectServiceType = Constant.PROJECT_SERVICE_TYPE.DESK_OFF;
                } else {
                    projectList[i].projectServiceType = !projectList[i].isPublic ? Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF : Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON;
                }
            }

            setListProject(projectList);
        }
    }, []);
    
    useEffect(() => {
        checkDisableBtnSubmit(argsAll);
    },[listEditProject, projectAddList]);

    useEffect(() => {
        const lastKey = Object.keys(initListEditProject).slice(-1)[0];
        document.getElementById(`input-project-${lastKey}`)?.focus()
    },[initListEditProject])

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (!Utils.isEmptyArray(projectAddList) || !Utils.isEmptyObject(listEditProject)) {
                setIsConfirmCancelTabs(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    },[closeTabIdState])

    // const handleOpenSettingIframe = (tabId, projectDetail) => {
    //     addNewPanel({
    //         type: Constant.PANEL_TYPE.SYSTEM_MANAGEMENT, 
    //         tabId: `${tabId}_${projectDetail.id}`,
    //         projectDetail: projectDetail,
    //         props
    //     });
    // }
    const getProjectServiceType = (projectDetail) => {
        let projectServiceType = '';
        let isDesk = listEditProject.hasOwnProperty(projectDetail.id) ? listEditProject[`${projectDetail.id}`]?.desk : projectDetail.isDesk
        let isPublicDesk = listEditProject.hasOwnProperty(projectDetail.id) ? listEditProject[`${projectDetail.id}`]?.public : Utils.isPublicDesk(projectDetail)
        if (!isDesk) {
            projectServiceType = Constant.PROJECT_SERVICE_TYPE.DESK_OFF;
        } else {
            projectServiceType = !isPublicDesk ? Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF : Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON;
        }
        return projectServiceType;
    }

    const getValueProjectServiceType = (project) => {
        if (!project.desk) {
            return Constant.PROJECT_SERVICE_TYPE.DESK_OFF;
        } else {
            return !project.public ? Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF : Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON;
        }
    }

    const enabledIframeLinkEmbed = (project) => {
        const deskService = corporationDetail.deskService;
        const publicWebForm = corporationDetail.limitValue.publicWebForm;

        return Boolean(Utils.isPublicDesk(project) && isAdmin && deskService && publicWebForm);
    }

    return (
        <div className="projectManagement">
            <LoadingPanel isLoading={isLoading} />
            <div className='head-btn'>
                <div className='head-btn-add'>
                    {getPermissionCreateProject(isAdmin,corporationDetail.contractType) && <Button className="btn-add-project" 
                        onClick={() => addNewProject(argsAll)}
                    >
                        <div className="btn-plus-icon"><img src="/assets/image/icon-plus-add.svg" alt="" /></div>
                        <div className='btn-text-add'>{I18n.get('USER03BTN004')}</div>
                    </Button> }

                </div>
                <div className='head-btn-wrap'>
                    <div className={`btn-cancel ${Utils.isEmptyArray(projectAddList) && Utils.isEmptyObject(listEditProject) ? 'hide-btnSubmit':''}`}>
                        <Button
                            onClick={() => handleCancelProject(argsAll)}
                            className="btn-light btn-hg32"
                            variant="contained"
                            color="primary"
                            disabled={Utils.isEmptyArray(projectAddList) && Utils.isEmptyObject(listEditProject)}
                        >
                            {I18n.get('COMBTN001')}
                        </Button>
                    </div>
                    <div className={`btn-submit ${Utils.isEmptyArray(projectAddList) && Utils.isEmptyObject(listEditProject) ? 'hide-btnSubmit':''}`}>
                        <Button
                            onClick={() => handleSubmitListProject(argsAll)}
                            className="btn-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            disabled={isDisableBtnSubmit}
                        >
                            {I18n.get('COMBTN011')}
                        </Button>
                    </div>
                </div>
            </div>
            <div className="project-body">
                    <table className='tableInfo'>
                        <thead>
                            <tr>
                                <th>{I18n.get('USER03LB001')}</th>
                                <th>{I18n.get('USER03LB002')}</th>
                                <th>{I18n.get('COMLB002')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projectAddList.map((project, index) => (
                                <tr key={index}>
                                    <td className='table-row-top'>
                                        <TextField 
                                            className='form-control-wrapInput form-control-hg32'
                                            variant="outlined"
                                            defaultValue={project.projectName}
                                            value={project.projectName}
                                            onChange={(e) =>onChangeProjectName(e, project.id, argsAll)}
                                            error={project.errors}
                                            helperText={project.errors}
                                        />
                                    </td>
                                    <td className='table-row-top width_288px'>
                                        <FormControl
                                            variant="outlined"
                                            className="form-control--wrap form-control--hg32"
                                            style={{textAlign: 'left'}}
                                        >
                                            <Select
                                                variant="outlined"
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: 'bottom',
                                                        horizontal: 'left'
                                                    },
                                                    transformOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'left'
                                                    },
                                                    getContentAnchorEl: null,
                                                    className: 'selectDrop'
                                                }}
                                                displayEmpty
                                                defaultValue={getValueProjectServiceType(project)}
                                                value={getValueProjectServiceType(project)}
                                                onChange={event =>
                                                    onChangeProjectServiceType(index, event, project.id, argsAll)
                                                }
                                            >
                                                <MenuItem value={Constant.PROJECT_SERVICE_TYPE.DESK_OFF}>{Constant.PROJECT_SERVICE_TYPE.DESK_OFF}</MenuItem>
                                                <MenuItem value={Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF}>{Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF}</MenuItem>
                                                {
                                                    corporationDetail.deskService ===
                                                    Constant.STATUS_SERVICE_PERMISSION.ON && (
                                                        <MenuItem
                                                            value={
                                                                Constant.PROJECT_SERVICE_TYPE
                                                                    .DESK_ON_PUBLIC_ON
                                                            }
                                                        >
                                                            {
                                                                Constant.PROJECT_SERVICE_TYPE
                                                                    .DESK_ON_PUBLIC_ON
                                                            }
                                                        </MenuItem>
                                                )}
                                            </Select>
                                        </FormControl>
                                    </td>
                                    <td className='table-row-top'>
                                        <div 
                                            className="btnItem-project" 
                                            style={{padding: '3px 0 0 0'}}
                                            onClick={() => onRemoveProject(project.id, argsAll)}
                                        >
                                            <Button className='btn-project'><img src="/assets/image/delete-icon.svg" alt="" /></Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                            {listProject?.filter(
                                project => ![Constant.PROJECT_TYPE.BASE,Constant.PROJECT_TYPE.CUSTOMER].includes(project.type)
                                )?.map((project, index) => (
                                    <tr key={index}>
                                        {!listEditProject.hasOwnProperty(project.id) ? (
                                            <td>
                                                <OverFlowTooltipWithTabsMui
                                                    value={Utils.getTextByLanguage(
                                                        Constant.LANGUAGE_TYPE.JP,
                                                        project.name
                                                    )}
                                                    className={`projectText ${project.active ===
                                                        Constant.ACTIVE_FLAG.DELETED &&
                                                        'projectText-deleted'}`}
                                                />
                                            </td>
                                        ) : (
                                            <td className='table-row-top'>
                                                {' '}
                                                <TextField
                                                    id={`input-project-${project.id}`}
                                                    className="form-control-wrapInput form-control-hg32"
                                                    variant="outlined"
                                                    placeholder={I18n.get('USER03LB001')}
                                                    inputProps={{ maxLength: 200 }}
                                                    defaultValue={Utils.getTextByLanguage(
                                                        Constant.LANGUAGE_TYPE.JP,
                                                        project.name
                                                    )}
                                                    value={listEditProject[`${project.id}`]?.name}
                                                    onChange={e =>
                                                        onChangeEditProjectName(e, project.id, argsAll)
                                                    }
                                                    error={listEditProject[`${project.id}`]?.error}
                                                    helperText={listEditProject[`${project.id}`]?.error}
                                                />
                                            </td>
                                        )}
                                        <td className='table-row-top width_288px'>
                                            <FormControl
                                                variant="outlined"
                                                className="form-control--wrap form-control--hg32"
                                                style={{textAlign: 'left'}}
                                            >
                                                <Select
                                                    variant="outlined"
                                                    MenuProps={{
                                                        anchorOrigin: {
                                                            vertical: 'bottom',
                                                            horizontal: 'left'
                                                        },
                                                        transformOrigin: {
                                                            vertical: 'top',
                                                            horizontal: 'left'
                                                        },
                                                        getContentAnchorEl: null,
                                                        className: 'selectDrop'
                                                    }}
                                                    displayEmpty
                                                    disabled={
                                                        !listEditProject.hasOwnProperty(project.id)
                                                    }
                                                    defaultValue={getProjectServiceType(project)}
                                                    value={getProjectServiceType(project)}
                                                    onChange={event =>
                                                        onChangeEditProjectServiceType(index, event, project.id, argsAll)
                                                    }
                                                >
                                                    <MenuItem value={Constant.PROJECT_SERVICE_TYPE.DESK_OFF}>{Constant.PROJECT_SERVICE_TYPE.DESK_OFF}</MenuItem>
                                                    <MenuItem value={Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF}>{Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF}</MenuItem>
                                                    {
                                                        corporationDetail?.deskService ===
                                                        Constant.STATUS_SERVICE_PERMISSION.ON && (
                                                        <MenuItem
                                                            value={
                                                                Constant.PROJECT_SERVICE_TYPE
                                                                    .DESK_ON_PUBLIC_ON
                                                            }
                                                        >
                                                            {
                                                                Constant.PROJECT_SERVICE_TYPE
                                                                    .DESK_ON_PUBLIC_ON
                                                            }
                                                        </MenuItem>
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </td>
                                        <td className='table-row-top'>
                                            <div className="btnItem-project" style={{padding: '3px 0 0 0'}}>
                                                {/* {enabledIframeLinkEmbed(project) &&
                                                    <Button className='btn-project'
                                                        disabled={project.active !== Constant.ACTIVE_FLAG.ACTIVE}
                                                        onClick={() => handleOpenSettingIframe(Constant.PANEL_TYPE.SYSTEM_PROJECT_SETTING_IFRAME, project)}>
                                                        <img src="/assets/image/setting-iframe.svg" alt="" />
                                                    </Button>
                                                } */}
                                                {/* dungnv 20092022 tạm ẩn vì chờ qa */}
                                                {getPermissionEditProject(isAdmin,project.type,project.isProjectManager,corporationDetail.contractType) && (
                                                    <Button
                                                        className={`btn-project ${listEditProject.hasOwnProperty(project.id) ? 'hide-btnEdit' :''}`}
                                                        onClick={() => handleEditProject(argsAll, project)}
                                                        disabled={project.active !== Constant.ACTIVE_FLAG.ACTIVE}
                                                    >
                                                        <img src="/assets/image/edit-icon.svg" alt="" />
                                                    </Button>
                                                )}
                                                {/* {!(
                                                    project.type === Constant.PROJECT_TYPE.BASE ||
                                                    project.type === Constant.PROJECT_TYPE.CUSTOMER ||
                                                    !project.isProjectManager
                                                ) && (
                                                    <Button
                                                        className={`btn-project ${listEditProject.hasOwnProperty(project.id) ? 'hide-btnEdit' :''}`}
                                                        onClick={() => handleEditProject(argsAll, project)}
                                                        disabled={project.active !== Constant.ACTIVE_FLAG.ACTIVE}
                                                    >
                                                        <img src="/assets/image/edit-icon.svg" alt="" />
                                                    </Button>
                                                )} */}
                                                 {/* dungnv 20092022 tạm ẩn vì chờ qa */}
                                                {getPermissionDeleteProject(isAdmin,project.type,project.isProjectManager,corporationDetail.contractType) && (
                                                    <Button className="btn-project" disabled={project.active !== Constant.ACTIVE_FLAG.ACTIVE}>
                                                        <img
                                                            src="/assets/image/delete-icon.svg"
                                                            alt=""
                                                            onClick={() => onClickDeleteProject(argsAll, project)}
                                                        />
                                                    </Button>
                                                )}
                                               {/*  {!(
                                                    project.type === Constant.PROJECT_TYPE.BASE ||
                                                    project.type === Constant.PROJECT_TYPE.CUSTOMER
                                                ) && (
                                                    <Button className="btn-project" disabled={project.active !== Constant.ACTIVE_FLAG.ACTIVE}>
                                                        <img
                                                            src="/assets/image/delete-icon.svg"
                                                            alt=""
                                                            onClick={() => onClickDeleteProject(argsAll, project)}
                                                        />
                                                    </Button>
                                                )} */}

                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                            
                        </tbody>
                    </table>
            </div>
            <CancelDialogProjectManagement argsAll={argsAll}/>
            <DeleteProjectManagementDialog argsAll={argsAll}/>
            <CancelTabsDialog argsAll={argsAll}/>
        </div>
    );
}
